import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';

const EmailEntry = ({ onEmailSubmit, label = 'Please Enter Your Email', requireValidEmail = true }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    setTimeout(() => {
      onEmailSubmit(values.email);
      form.resetFields();
      setLoading(false);
    }, 1000);
  };

  const onFinishFailed = (errorInfo) => {
    message.error('Please enter a valid email address');
  };

  return (
    <Form
      form={form}
      name="email-entry"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="vertical"
    >
      <Form.Item
        name="email"
        label={label}
        rules={
          requireValidEmail
            ? [
                {
                  type: 'email',
                  message: 'Please enter a valid email address',
                },
                {
                  required: true,
                  message: 'Please enter your email address',
                },
              ]
            : [
                {
                  required: true,
                  message: 'Please enter your email address',
                },
              ]
        }
      >
        <Input size={'large'} placeholder="Enter your email" />
      </Form.Item>

      <Form.Item>
        <Button
          ghost={true}
          size={'large'}
          type="primary"
          htmlType="submit"
          loading={loading}
          style={{ color: '#fff', width: '100%' }}
        >
          Submit & Continue
        </Button>
      </Form.Item>
    </Form>
  );
};

export default EmailEntry;
